"use strict";

exports.__esModule = true;
exports.UndoContext = void 0;
var _Utils = require("../../../Utils");
/**
 * Context for undo, redo + history.
 *
 * @component
 */
var UndoContext = exports.UndoContext = (0, _Utils.createEnhancedContext)({
  propName: "undo"
});